import './units-available.scss';
import { DateTime } from 'luxon';
import { useEffect, useState } from 'react';
import { useCustomerAPI } from '../../../../clients/customer-api/customer-api-client';
import { OrderType } from '../../../../clients/quipli-service/order/order';

export const UnitsAvailable = ({
  productId,
  locationId,
  startDateTime,
  endDateTime,
  type = OrderType.Rental,
}: {
  productId: number;
  locationId: number;
  startDateTime: DateTime | undefined;
  endDateTime: DateTime | undefined;
  type?: OrderType;
}) => {
  const { getAvailableCount } = useCustomerAPI();
  const [unitsAvailable, setUnitsAvailable] = useState<number>();

  const updateUnitsAvailable = async () => {
    if (startDateTime && endDateTime) {
      const av = await getAvailableCount(productId, locationId, startDateTime, endDateTime, type);
      setUnitsAvailable(av);
    } else {
      setUnitsAvailable(undefined);
    }
  };

  useEffect(() => {
    updateUnitsAvailable();
  }, [startDateTime, endDateTime]);

  return (
    <div className="units-available">
      {unitsAvailable ? `There are ${unitsAvailable.toFixed(2)} units available` : ''}
      {unitsAvailable === 0 ? 'No units are available during the selected time period' : ''}
    </div>
  );
};
